import { LOGOUT } from '@/helpers/enums/table-actions'
import { getLastActiveAt, dateFormatter } from '@/helpers/dateFormatter'
import { Session } from '@/typings/api/Session'
import { USERS_ROUTES as ROUTES } from '@/views/Users/utils'


export const TABLE_ACTIONS = Object.freeze([
  LOGOUT,
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Пользователь',
    value: 'username',
    sortable: false,
    getRoute: (data: Session) => ({
      name: ROUTES.VIEW,
      params: { id: data.user_id },
    }),
  },
  {
    text: 'IP',
    value: 'last_visited_ip',
    width: 130,
    sortable: false,
  },
  {
    text: 'Последняя активность',
    value: 'last_active_at',
    field: (value: Session['last_active_at']) => (
      value && getLastActiveAt(value, 2)
    ),
    width: 166,
    sortable: false,
  },
  {
    text: 'Истекает',
    value: 'expire_at',
    field: (value: Session['expire_at']) => (
      value && dateFormatter(value)
    ),
    width: 130,
    sortable: false,
  },
])
